import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { Node } from '@uncinc/react-drupal-core';
import { DEFAULT_FADE_DURATION_MS } from '../../../config/constants';

import {
  Loader,
} from '../../../components';

import './style.scss';

const KPQuestionsAll = ({ onLoadMore, pager, loading, entities, ...props }) => {
  return (
    <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
      <div className="View ViewKPQuestionsAll NewsSelection">
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <div key={`${uuid}:${langcode}`}>
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      <Loader loading={loading} />
    </Fade>
  );
};

export default KPQuestionsAll;
